export default __webpack_public_path__ + "static/media/traders-tab-active.a70d40db.svg";